import * as actionTypes from './actionTypes';

/**
 *  Initial State searchData Reducer
 */
const initialState = {
  data: false,
};
/**
 * On Get searchData Start Action
 */
const getSearchStateData = (state, action) => {
  return { ...state, data: action.payload };
};

/**
 * Update searchData Reducer
 */
export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_SEARCH_DATA:
      return getSearchStateData(state, action);
    default:
      return state;
  }
};
